import React from 'react';
import SEO from '../components/seo';
import ComponentList from '../components/ComponentList';

const IndexPage = ({ pageContext, location }) => {
  const { seo = {}, components = [] } = pageContext;

  const metaTitle = (seo && seo.metaTitle) || 'Eugenie Detroit';
  const openGraphTitle = (seo && seo.openGraphTitle) || 'Eugenie Detroit';
  const twitterTitle = (seo && seo.twitterTitle) || 'Eugenie Detroit';

  return (
    <React.Fragment>
      <SEO
        metaTitle={metaTitle}
        metaDescription={seo?.metaDescription}
        metaKeywords={seo?.metaKeywords}
        openGraphTitle={openGraphTitle}
        openGraphDescription={seo?.openGraphDescription}
        openGraphImage={seo?.openGraphImage}
        twitterTitle={twitterTitle}
        twitterDescription={seo?.twitterDescription}
        twitterImage={seo?.twitterImage}
        pathname={location.pathname}
      />
      {components && <ComponentList components={components} />}
    </React.Fragment>
  );
};

export default IndexPage;
